import { FunctionComponent, useCallback } from 'react'
import classNames from 'classnames'
import { Modal, RoundedButton } from '../../shared'
import { ConversationHistoryList } from '../ConversationHistoryList'
import { EditableConversationTitle } from '../EditableConversationTitle'
import { StatsConversation } from '../StatsConversation'
import { StatsDisclaimer } from '../StatsDisclaimer'
import { TooltipIconButton } from '../TooltipIconButton'
import modalStyles from '../../shared/modal/Modal/Modal.module.scss'
import { StatsExpandedModalProps } from './StatsExpandedModal.model'
import styles from './StatsExpandedModal.module.scss'

export const StatsExpandedModal: FunctionComponent<StatsExpandedModalProps> = ({ chat }) => {
  const { conversationUlid, startNewConversation } = chat

  const handleDeleted = useCallback(
    (ulid: string) => {
      if (ulid === conversationUlid) startNewConversation()
    },
    [conversationUlid, startNewConversation],
  )

  if (!chat.isExpanded) return null

  return (
    <Modal
      isUnmounting={false}
      // Plein écran : la scrollbar de la page derrière restait cliquable et repliait la modale.
      lockScroll={chat.isFullscreen}
      onClickOutside={chat.isFullscreen ? undefined : chat.reduceToCompactPanel}
      testId="stats-assistant-expanded"
      veilClassName={classNames(modalStyles.backgroundVeilElevated, {
        [styles.veilFullscreen]: chat.isFullscreen,
      })}
    >
      <div className={classNames(styles.layout, { [styles.layoutFullscreen]: chat.isFullscreen })}>
        <aside className={styles.sidebar}>
          <div className={styles.sidebarHeader}>
            <span className={styles.sidebarTitle}>Historique</span>
            <RoundedButton
              label="Nouvelle"
              icon="add"
              theme="transparent-dark"
              size="nano"
              // Déjà sur une nouvelle analyse : rien à réinitialiser.
              disabled={chat.conversationUlid === null}
              onClick={chat.startNewConversation}
              testId="button-stats_assistant-modal-new_analysis"
            />
          </div>
          <ConversationHistoryList
            activeUlid={chat.conversationUlid}
            onSelect={chat.selectConversation}
            onDeleted={handleDeleted}
          />
        </aside>

        <section className={styles.main}>
          <div className={styles.mainHeader}>
            <EditableConversationTitle
              ulid={chat.conversationUlid}
              title={chat.title}
              className={styles.mainTitle}
            />
            <div className={styles.headerActions}>
              <StatsDisclaimer />
              <TooltipIconButton
                icon="caret"
                rotate={180}
                size="micro"
                label={chat.isFullscreen ? 'Quitter le plein écran' : 'Réduire au panneau'}
                onClick={
                  chat.isFullscreen ? () => chat.setIsFullscreen(false) : chat.reduceToCompactPanel
                }
                testId="button-stats_assistant-modal-reduce"
              />
              {!chat.isFullscreen && (
                <TooltipIconButton
                  icon="caret"
                  size="micro"
                  label="Plein écran"
                  onClick={() => chat.setIsFullscreen(true)}
                  testId="button-stats_assistant-modal-fullscreen"
                />
              )}
              <TooltipIconButton
                icon="cross"
                size="micro"
                label="Fermer"
                onClick={chat.collapseAssistant}
                testId="button-stats_assistant-modal-close"
              />
            </div>
          </div>
          <StatsConversation chat={chat} />
        </section>
      </div>
    </Modal>
  )
}
